// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Excel-like compact table styles */
.compact-stats-table .ant-table-thead > tr > th {
  padding: 0 6px !important;
  height: 28px !important;
  line-height: 28px !important;
  border-bottom: 2px solid #555 !important;
}

.compact-stats-table .ant-table-tbody > tr:not(.ant-table-measure-row) > td {
  padding: 0 6px !important;
  height: 22px !important;
  line-height: 22px !important;
}

.compact-stats-table .ant-table-container {
  border-spacing: 0;
}

.compact-stats-table .ant-table-cell {
  line-height: 1.2;
}

/* Highlighted row styles - using more contrasting colors */
.highlighted-row {
  background-color: #ffec99 !important;
  border-left: 4px solid #fa541c !important;
  box-shadow: inset 0 0 0 1px #fa541c33 !important;
}

/* Ensure highlighted state takes precedence over row type styles and hover */
.campaign-metric-row.highlighted-row,
.nm-metric-row.highlighted-row,
.calculated-metric-row.highlighted-row,
.percentage-metric-row.highlighted-row {
  background-color: #ffec99 !important;
  border-left: 4px solid #fa541c !important;
  box-shadow: inset 0 0 0 1px #fa541c33 !important;
}

/* Highlighted rows on hover - keep the highlight visible */
.campaign-metric-row.highlighted-row:hover,
.nm-metric-row.highlighted-row:hover,
.calculated-metric-row.highlighted-row:hover,
.percentage-metric-row.highlighted-row:hover,
.highlighted-row:hover {
  background-color: #ffec99 !important;
  border-left: 4px solid #fa541c !important;
  box-shadow: inset 0 0 0 1px #fa541c33 !important;
}

/* Ensure all cells in highlighted rows get the same background */
.highlighted-row td {
  background-color: inherit !important;
}

.highlighted-row:hover td {
  background-color: inherit !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductStatsTable/ProductStatsTable.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,oCAAoC;EACpC,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA,6EAA6E;AAC7E;;;;EAIE,oCAAoC;EACpC,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA,2DAA2D;AAC3D;;;;;EAKE,oCAAoC;EACpC,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA,iEAAiE;AACjE;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* Excel-like compact table styles */\n.compact-stats-table .ant-table-thead > tr > th {\n  padding: 0 6px !important;\n  height: 28px !important;\n  line-height: 28px !important;\n  border-bottom: 2px solid #555 !important;\n}\n\n.compact-stats-table .ant-table-tbody > tr:not(.ant-table-measure-row) > td {\n  padding: 0 6px !important;\n  height: 22px !important;\n  line-height: 22px !important;\n}\n\n.compact-stats-table .ant-table-container {\n  border-spacing: 0;\n}\n\n.compact-stats-table .ant-table-cell {\n  line-height: 1.2;\n}\n\n/* Highlighted row styles - using more contrasting colors */\n.highlighted-row {\n  background-color: #ffec99 !important;\n  border-left: 4px solid #fa541c !important;\n  box-shadow: inset 0 0 0 1px #fa541c33 !important;\n}\n\n/* Ensure highlighted state takes precedence over row type styles and hover */\n.campaign-metric-row.highlighted-row,\n.nm-metric-row.highlighted-row,\n.calculated-metric-row.highlighted-row,\n.percentage-metric-row.highlighted-row {\n  background-color: #ffec99 !important;\n  border-left: 4px solid #fa541c !important;\n  box-shadow: inset 0 0 0 1px #fa541c33 !important;\n}\n\n/* Highlighted rows on hover - keep the highlight visible */\n.campaign-metric-row.highlighted-row:hover,\n.nm-metric-row.highlighted-row:hover,\n.calculated-metric-row.highlighted-row:hover,\n.percentage-metric-row.highlighted-row:hover,\n.highlighted-row:hover {\n  background-color: #ffec99 !important;\n  border-left: 4px solid #fa541c !important;\n  box-shadow: inset 0 0 0 1px #fa541c33 !important;\n}\n\n/* Ensure all cells in highlighted rows get the same background */\n.highlighted-row td {\n  background-color: inherit !important;\n}\n\n.highlighted-row:hover td {\n  background-color: inherit !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
